import { IconButton } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { GridOverlay } from "@material-ui/data-grid";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../../App/AppContext";
import { SecondaryButton } from "../../../Core/FormInput/index";
import DataGridComp from "../../../Core/Grid";
import AddDefectActionedCategoriesModal from "./AddUpdateModal";
import { getDefectActionedCategories } from "../../../Core/Service/DefectActionedCategory-service";


const DefectActionedCategories = (props) => {
    const [state, setState] = useState({
        rows: [],
        show: false,
        DefectActionedCategoryDetails: [],
        showDel: false,
    });
    const { showToast } = useContext(AppContext);

    useEffect(async () => {
        pullDefectActionedCatagoriesAndUpdateState();
    }, []);

    const handleUpdate = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                show: true,
                DefectActionedCategoryDetails: params.value.row,
            };
            return nst;
        });
    };

    const Arrow = (params) => {
        return (
            <>
                <Tooltip title="Update Defect Actioned Catagory" aria-label="add">
                    <IconButton size="small" onClick={() => handleUpdate(params)}>
                        <EditOutlinedIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        );
    };

    const column_new = [
        {
            field: "",
            headerName: "Action",
            sortable: false,
            width: 120,
            renderCell: (params) => <Arrow value={params} />,
        },
        {
            field: 'id', //defectActionedCategoryID
            headerName: 'Code',
            width: 200,
        },
        {
            field: "defectActionedCategoryDescription",
            headerName: "Description",
            flex: 1,
        },
    ];

    const pullDefectActionedCatagoriesAndUpdateState = async () => {
        let result = await getDefectActionedCategories();
        if (result.success) {
            setState((st) => ({
                ...st,
                rows: result.data.list.map((w) => ({
                    ...w,
                    id: w.defectActionedCategoryID,
                    defectActionedCategoryDescription: w.defectActionedCategoryDescription,
                })),
                show: false,
                showDel: false,
            }));
        }
        if (!result.success) {
            showToast(result.message);
        }
    };

    const handleAdd = (props) => {
        setState((st) => {
            return {
                ...st,
                show: true,
                DefectActionedCategoryDetails: null,
            };
        });
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No defect reported categories available</div>
            </GridOverlay>
        );
    }

    const closeUpdateUser = (refreshGrid) => {
        setState((st) => ({ ...st, show: false, showDel: false }));
        refreshGrid && pullDefectActionedCatagoriesAndUpdateState();
    };

    return (
        <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", right: 0 }}>
                <SecondaryButton variant="contained" color="secondary" onClick={handleAdd} className="btnadd">
                    Add Defect Actioned Category
                </SecondaryButton>
            </div>
            {state.show ? (
                <AddDefectActionedCategoriesModal onFormSubmit={closeUpdateUser} DefectActionedCategoryDetails={state.DefectActionedCategoryDetails} />
            ) : null}
            <Breadcrumbs separator=">>" aria-label="breadcrumb">
                <Link color="inherit" to={"/"}>
                    Home
                </Link>
                <Typography color="secondary" style={{ fontSize: "0.85rem" }}>
                    Defect Actioned Catagories
                </Typography>
            </Breadcrumbs>
            <DataGridComp rows={state.rows} columns={column_new} enableSearch={true} offset={244} CustomNoRowsOverlay={CustomNoRowsOverlay} />
        </div>
    );
};
export default DefectActionedCategories;